import { Product, SiteSettings } from "../types";

export const DEFAULT_SETTINGS: SiteSettings = {
  title: "شرکت تجارتی الماس سروری",
  subtitle: "واردکننده تخصصی ماشین‌آلات سنگبری و موزاییک‌سازی در افغانستان | بزرگترین تامین‌کننده خطوط تولید و تجهیزات معدن در کابل و هرات",
  subtitleEn: "Leading Importer of Stone Cutting & Mosaic Machinery in Afghanistan | Kabul & Herat Industrial Solutions",
  contactPhone: "0787947200",
  address: "افغانستان - هرات، سرک باغ ملت، مقابل رستورانت هزارویکشب",
  email: "info@almassarvari.com",
  currency: "افغانی",
  enableInteractiveBuilder: false,
  announcement: "📌 واردات مستقیم دستگاه‌های قله‌بر و پالش اسلب از برندهای معتبر جهانی شارژ شد.",
  logoUrl: "https://osymbnivgxwtxymgzvre.supabase.co/storage/v1/object/public/platform-assets/almas-logo.png",
  heroBgUrl: "https://images.unsplash.com/photo-1551458601-14e8150ece4b?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  categories: [],
  units: [],
  blogPageLabel: "مجله تخصصی و وبلاگ",
  blogPageLabelEn: "The Official Blog",
  blogPageTitle: "آموزش و اخبار بازرگانی",
  blogPageTitleEn: "Industrial Insights & News",
  landingBlogLabel: "آکادمی و وبلاگ تخصصی",
  landingBlogLabelEn: "Industrial Insights",
  landingBlogTitle: "آخرین مقالات و آموزش‌های تخصصی",
  landingBlogTitleEn: "Latest Technical Articles & Training"
};

export const DEFAULT_PRODUCTS: Product[] = [
  {
    id: "almas-1",
    name: "دستگاه قله‌بر ۳۰ تیغه تمام اتوماتیک",
    sku: "ALM-GB-30",
    category: ["ماشین‌آلات سنگبری"],
    price: 0,
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=800",
    description: "دستگاه قله‌بر مدرن با قابلیت نصب ۳۰ تیغه همزمان، مجهز به سیستم کنترل PLC و دقت برش میلی‌متری.",
    specs: {
      brand: "GENSA",
      origin: "ترکیه",
      mesh: "برش اسلب",
      packing: "نصب در محل",
      colorIndex: "Automatic",
      usage: "کارخانجات سنگبری بزرگ",
    },
    stock: true,
    isFeatured: true,
  },
  {
    id: "almas-2",
    name: "ماشین پالش اسلب ۱۶ کله",
    sku: "ALM-PL-16",
    category: ["دستگاه‌های کفسابی"],
    price: 0,
    image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=800",
    description: "خط پالش اسلب مجهز به ۱۶ کله ساینده با فشار پنوماتیک هوشمند جهت براقیت فوق‌العاده سنگ‌های ماربل و گرانیت.",
    specs: {
      brand: "WAN",
      origin: "چین (درجه ۱)",
      mesh: "ساب و پالش",
      packing: "کانتینر اختصاصی",
      colorIndex: "High Gloss",
      usage: "فرآوری نهایی اسلب‌های صادراتی",
    },
    stock: true,
    isFeatured: true,
  }
];
